import { render, staticRenderFns } from "./material-modal.vue?vue&type=template&id=ec4d3c1e&scoped=true"
import script from "./material-modal.vue?vue&type=script&lang=js"
export * from "./material-modal.vue?vue&type=script&lang=js"
import style0 from "./material-modal.vue?vue&type=style&index=0&id=ec4d3c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d3c1e",
  null
  
)

export default component.exports